// Module
var code = `<input class="tft-input {{tftInputCtrl.className}}" type="{{tftInputCtrl.type || 'text'}}" ng-required="tftInputCtrl.required" ng-model="tftInputCtrl.innerValue" ng-change="tftInputCtrl.valueChange()" placeholder="{{tftInputCtrl.formattedPlaceholder}}" ng-focus="tftInputCtrl.onFocus()" data-test-id="{{tftInputCtrl.testId}}"/>`;
// Exports
export default code;